import { activityInfoState } from "@/App"
import { LayoutDesktop } from "@/components/LayoutPC/LayoutDesktop"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import './DGuide.scss'
import BlankPage from "@/components/Error/blank"



export const DesktopGuide = () => {


    const navigate = useNavigate()

    const info = useRecoilValue(activityInfoState)

    if (info.remark.length === 0) {
        return <BlankPage />
    }

    return (
        <LayoutDesktop>
            <div className='desktop-content-view'>
                <div className='desktop-guide-title'></div>
                <div className='desktop-guide-container'>
                    <div className="desktop-guide-container-text">{info.remark}</div>
                </div>
                <div className='desktop-guide-control'>
                    <div className='desktop-guide-control-left pointer' onClick={() => {
                        navigate('/', { replace: true })
                    }}></div>
                </div>
            </div>
        </LayoutDesktop>
    )

}